import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, Router } from "@angular/router";
import { TranslateService } from "../service/translate.service";
import { Language } from "src/app/transloco.config";
import { getLanguageValues } from "src/app/shared/utils";

@Injectable({
  providedIn: "root",
})
export class LanguageResolver implements Resolve<void> {
  private readonly _supportedLanguages = getLanguageValues();

  constructor(
    private _translateService: TranslateService,
    private _router: Router,
  ) {}

  public resolve(route: ActivatedRouteSnapshot): void {
    let lang = (route.paramMap.get("lang") || Language.EN) as Language;

    if (!this._supportedLanguages.includes(lang)) {
      lang = Language.EN;
    }

    if (lang !== this._translateService.getSelectedLanguage()) {
      this._translateService.setLanguage(lang);

      this._router.navigate([`/${lang}`]).then(() => {
        window.location.reload();
      });
    }
  }
}
